
const digest = '05c5dc4abca727d63fe136e92cfa7374a2a4325208ccbba63adf5c9e20120dd4';
const classes = {"wrapper":"_wrapper_po885_1","button":"_button_po885_6"};
const css = `._wrapper_po885_1 {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
._wrapper_po885_1 ._button_po885_6 {
  width: fit-content;
  min-width: 100px;
  margin-top: 20px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  